import { defineSaleProgress, hasAddress, isSaleCreated, type ProgressSaleData } from '../saleProgress'

interface LeadAssuranceData extends ProgressSaleData {
  leadType?: string | null
  moreThanOneYearContract?: string | null
  saleTopics?: string[] | null
  description?: string | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

const hasAnswer = (data: LeadAssuranceData) =>
  !!data.moreThanOneYearContract || (data.saleTopics?.length ?? 0) > 0 || !!data.description

export default defineSaleProgress<LeadAssuranceData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'qualified', label: `${TIMELINE}qualified`, done: data => !!data.leadType },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    const isInProgress = steps.some(step => step.state === 'done') || hasAnswer(data) || !!data.actionsInProgress
    if (isInProgress) return 'progress'

    return 'new'
  },
})
